import React from "react";
import PropTypes from "prop-types";
import Modal, { MODAL_SIZE } from "components/Modal";
import { RolesList } from "components/Missions/Roles";

/**
 * MissionRolesPicker
 *
 * @param {Function} onItemClick
 * @param {Function} onSelect
 * @param {Boolean}  show
 * @param {Function} onClose
 * @param {Boolean}  selectable
 * @param {Boolean}  showSave
 */
const MissionRolesPicker = ({ show, showSave, onClose, onItemClick, onSelect, selectable, ...props }) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      showSave={showSave}
      secondaryButtonMessageId="Global.Close"
      size={MODAL_SIZE.xlarge}
      showCancel
      {...props}
    >
      <RolesList
        onItemClick={onItemClick}
        onSelect={onSelect}
        selectable={selectable}
        showAdvancedOptions={false}
        // Without this prop, the selection seems to be cleared on data arrival by DataTable component
        // This is a workaround to keep the selection when the data is updated
        clearable={false}
        {...props}
      />
    </Modal>
  );
};

MissionRolesPicker.defaultProps = {
  show: false,
  selectable: false,
  showSave: false,
};

MissionRolesPicker.propTypes = {
  onItemClick: PropTypes.func,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  selectable: PropTypes.bool,
  showSave: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default MissionRolesPicker;
